import React from "react";
import ModalActivity from "@iso/containers/Pages/HealthSafety/ModalActivity";
import ResolveHazardModal from "@iso/components/Hazards/ResolveHazardModal";
import ReopenHazardModal from "@iso/components/Hazards/ReopenHazardModal";
import ManualEscalateModal from "@iso/components/Hazards/ManualEscalateModal";
import ConfirmImmediateResolutionModal from "@iso/components/Hazards/ConfirmImmediateResolutionModal";
import { getSafetyActivityHazardLabel } from "@iso/constants/hazardTypes";

const HazardActionModals = ({
  // State from useHazardActions
  editModalVisible,
  editingHazard,
  resolveModalVisible,
  resolveHazard,
  escalateModalVisible,
  escalateHazard,
  reopenModalVisible,
  reopenHazard,
  confirmResolutionModalVisible,
  confirmResolutionHazard,

  // Handlers from useHazardActions
  handleEditClose,
  handleResolveClose,
  handleResolveSuccess,
  handleEscalateClose,
  handleEscalateSuccess,
  handleReopenClose,
  handleReopenSuccess,
  handleConfirmResolutionClose,
  handleConfirmResolutionSuccess,

  // Consumer-provided props
  propertyId,
  onRefresh,
}) => {
  return (
    <>
      {/* Edit Modal */}
      <ModalActivity
        visibleModalActivity={editModalVisible}
        cancelModalActivity={handleEditClose}
        activityActive="hazard"
        editingPolicy={editingHazard}
        propertyId={editingHazard?.property_id || propertyId}
        searchAssetAndPolicy={onRefresh}
        saveToHazardsTable={true}
      />

      {/* Resolve Modal */}
      <ResolveHazardModal
        visible={resolveModalVisible}
        hazardId={resolveHazard?.id}
        onCancel={handleResolveClose}
        onSuccess={handleResolveSuccess}
      />

      {/* Reopen Modal */}
      <ReopenHazardModal
        visible={reopenModalVisible}
        hazardId={reopenHazard?.id}
        hazardTitle={reopenHazard?.hazard_type || reopenHazard?.title}
        onCancel={handleReopenClose}
        onSuccess={handleReopenSuccess}
      />

      {/* Escalate Modal */}
      <ManualEscalateModal
        visible={escalateModalVisible}
        hazardId={escalateHazard?.id}
        hazardTitle={
          getSafetyActivityHazardLabel(escalateHazard?.hazard_type) ||
          escalateHazard?.title
        }
        currentLevel={escalateHazard?.current_escalation_level}
        onCancel={handleEscalateClose}
        onSuccess={handleEscalateSuccess}
      />

      {/* Confirm Immediate Resolution Modal */}
      <ConfirmImmediateResolutionModal
        visible={confirmResolutionModalVisible}
        hazard={confirmResolutionHazard}
        workflowState={confirmResolutionHazard?.workflow_state}
        onCancel={handleConfirmResolutionClose}
        onSuccess={handleConfirmResolutionSuccess}
      />
    </>
  );
};

export default HazardActionModals;
